import _ from 'lodash';
import axios from 'axios';

import apolloClient from '@/store/apollo';
import AuthenticatedMemberGql from '@/store/graphql/queries/AuthenticatedMember.gql';

const AUTH_ENDPOINT = _.trimEnd(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_MEMBER_AUTH_ROUTE}`, '/');
const REGISTER_ENDPOINT = _.trimEnd(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_MEMBER_REGISTER_ROUTE}`, '/');
const PASSWORD_ENDPOINT = _.trimEnd(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_MEMBER_PASSWORD_ROUTE}`, '/');
const MEMBER_EMAIL_VERIFICATION_ENDPOINT = _.trimEnd(`${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_MEMBER_EMAIL_VERIFICATION_ROUTE}`, '/');

export default {
    setToken(token) {
        return localStorage.setItem('member-token', token);
    },
    getToken() {
        return localStorage.getItem('member-token') || '';
    },
    removeToken: () =>
        new Promise(resolve => {
            // TODO
            // invalidate token server side

            localStorage.removeItem('member-token');
            setTimeout(() => resolve(), 150);
        }),
    register(member) {
        return new Promise((resolve, reject) => {
            axios
                .post(REGISTER_ENDPOINT, member)
                .then(result => resolve(result))
                .catch(error => reject(error));
        });
    },
    login(member) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${AUTH_ENDPOINT}/login`, member)
                .then(result => resolve(result))
                .catch(error => reject(error));
        });
    },
    sendResetLinkEmail(payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${PASSWORD_ENDPOINT}/email`, payload)
                .then(result => resolve(result))
                .catch(error => reject(error));
        });
    },
    resetPassword(payload) {
        return new Promise((resolve, reject) => {
            axios
                .post(`${PASSWORD_ENDPOINT}/reset`, payload)
                .then(result => resolve(result))
                .catch(error => reject(error));
        });
    },
    verifyEmail(payload) {
        return new Promise((resolve, reject) => {
            const config = {
                headers: {
                    Authorization: `Bearer ${payload.token}`
                }
            };
            axios
                .post(`${MEMBER_EMAIL_VERIFICATION_ENDPOINT}?expires=${payload.expires}&hash=${payload.hash}&id=${payload.id}&signature=${payload.signature}`, null, config)
                .then(result => resolve(result))
                .catch(error => reject(error));
        });
    },
    fetchAuthenticatedMember: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({ query: AuthenticatedMemberGql })
                .then(({ data }) => resolve(data.CP_AuthenticatedMember))
                .catch(error => reject(error.message));
        })
};
